import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './app/App';
import { FluentProvider } from '@fluentui/react-components';
import initialiseTranslations from './locales/initialise';
import { dolphinTheme } from './utils/Theme';

function removePlaceholder() {
	const placeholder = document.getElementById('placeholder');
  	if (placeholder) {
    	placeholder.remove();
  	}
}

function renderReactApp() {
	const rootElem = document.getElementById('root') as HTMLElement;
	const root = ReactDOM.createRoot(rootElem);

	root.render(
		<React.StrictMode>
			<FluentProvider theme={dolphinTheme}>
				<App />
			</FluentProvider>
		</React.StrictMode>
	);
}

initialiseTranslations();
renderReactApp();
removePlaceholder();
reportWebVitals();